module.exports = __webpack_public_path__ + "img/W-G32.6d05fac3.jpg";